import React from 'react';
import styled from 'styled-components';
import { Divider, Grid } from '@mui/material';
import { PAGE_COMMON_TEXT } from '../../lang';
import { type DistinctiveScholarship } from '../../../../Application/graphql';
import { LabelValue, TextField, DocumentBox } from '../../../../../components';
import { PAGE_TEXT } from '../../../../Application/components/ApplicationForm/lang';

const PRIORITY_TEXT = ['First Priority', 'Second Priority'];

const DISTINCTIVE_SCHOLARSHIP = PAGE_TEXT.FELLOWSHIP.DISTINCTIVE_SCHOLARSHIP;
export const DistinctiveScholarshipView: React.FunctionComponent<{
  distinctiveScholarships: DistinctiveScholarship[];
}> = props => {
  const { distinctiveScholarships } = props;
  const hasDistinctiveScholarships = distinctiveScholarships.length > 0;
  return (
    <div>
      {hasDistinctiveScholarships ? (
        <Container>
          {distinctiveScholarships.map((distinctiveScholarship, index) => {
            const { fundingSource, reason, files } = distinctiveScholarship;

            return (
              <Grid container key={index}>
                <h2 className="text-base font-medium pl-4 pb-2">
                  {PRIORITY_TEXT[index]}
                </h2>
                <Grid size={12}>
                  <LabelValue
                    label={`${PRIORITY_TEXT[index]} Distinctive Scholarship`}
                    value={fundingSource}
                  />
                  <Divider />
                </Grid>
                <Grid size={12}>
                  <div className="pl-4 pt-2 pb-2 pr-4">
                    <div className="mb-1 text-[#224295]">
                      {DISTINCTIVE_SCHOLARSHIP.REASON_EXPLANATION}
                    </div>
                    <TextField
                      value={reason}
                      multiline
                      fullWidth
                      disabled
                      minRows={3}
                    />
                  </div>
                  <Divider />
                </Grid>
                <Grid
                  sx={{
                    padding: '0.5rem 1rem',
                  }}
                  size={12}
                >
                  <div className="mb-1 text-[#224295]">
                    {DISTINCTIVE_SCHOLARSHIP.PROOF_DOCUMENT}
                  </div>
                  {files.map((file, index) => (
                    <DocumentBox key={index} file={file} />
                  ))}
                </Grid>
              </Grid>
            );
          })}
        </Container>
      ) : (
        <div>{PAGE_COMMON_TEXT.NA}</div>
      )}
    </div>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 1rem;
  font-size: 14px;

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 1rem !important;
  }
`;
